import '@/styles/globals.less';
import 'swiper/swiper-bundle.min.css';
import 'swiper/swiper.min.css';
import 'swiper/css/effect-fade';
import Head from 'components/Head';
import type { AppProps } from 'next/app';
import React from 'react';

const MyApp = ({ Component, pageProps }: AppProps) => {
  return (
    <>
      <Head />
      <Component {...pageProps} />
    </>
  );
};

export default MyApp;
